'use client'

import {
  FormButton,
  FormGroup,
  FormInput,
  FormTextarea,
} from '@/components/form'
import { sendTemplateEmail } from '@/services/postmark/postmark-server'
import { Form, Formik } from 'formik'
import { useState } from 'react'
import * as Yup from 'yup'

// Define validation schema with Yup
const validationSchema = Yup.object({
  name: Yup.string().required('Name is required'),
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  message: Yup.string().required('Message is required'),
})

const ContactUsForm = () => {
  const [formStatus, setFormStatus] = useState(null)

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const emailData = {
        to: 'support@pano.news',
        templateId: 39667135,
        templateModel: {
          name: values.name,
          email: values.email,
          message: values.message,
        },
      }

      // Call sendTemplateEmail function to send the email
      const emailResponse = await sendTemplateEmail(emailData)

      if (emailResponse.success) {
        setFormStatus(
          "Your message has been sent! You'll hear from us within 1-2 business days."
        )
      } else {
        setFormStatus('There was an issue sending your message.')
      }

      // Reset the form after submission
      resetForm()
    } catch (error) {
      console.error(error)
      setFormStatus('There was an error submitting your message.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="w-full">
      {formStatus && (
        <div
          className={`mb-6 p-4 rounded-sm border-l-4 font-serif text-sm ${
            formStatus.includes('error') || formStatus.includes('issue')
              ? 'bg-red-50 text-red-900 border-red-600 dark:bg-red-900/20 dark:text-red-300 dark:border-red-600'
              : 'bg-green-50 text-green-900 border-green-600 dark:bg-green-900/20 dark:text-green-300 dark:border-green-600'
          }`}
        >
          {formStatus}
        </div>
      )}

      <Formik
        initialValues={{ name: '', email: '', message: '' }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <FormGroup>
              <FormInput
                name="name"
                label="Name"
                placeholder="Your name"
                required
              />

              <FormInput
                name="email"
                type="email"
                label="Email"
                placeholder="Your email"
                required
              />

              <FormTextarea
                name="message"
                label="Message"
                placeholder="Enter your message..."
                rows={6}
                required
              />

              <div className="pt-2">
                <FormButton
                  type="submit"
                  disabled={isSubmitting}
                  variant="primary"
                  size="lg"
                  className="w-full sm:w-auto"
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </FormButton>
              </div>
            </FormGroup>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default ContactUsForm
